import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { StartCourseMessage } from "../../models/start-course-message.model";
import { EventMessage } from "../../models/event-message.model";

export namespace MessageActions {

  @logDispatcher
  export class GetEngagementMessages {
    static readonly type = '[MessageStatus] GetEngagementMessages';
    constructor(public currentDate: Date, public enventName: string) {}
  }

  @logDispatcher
  export class GetEngagementMessagesSuccess {
    static readonly type = '[MessageStatus] GetEngagementMessagesSuccess';
    constructor(public engagementMessages: EventMessage[]) {}
  }

  @logDispatcher
  export class GetContractMessages {
    static readonly type = '[MessageStatus] GetContractMessages';
    constructor(public currentDate: Date, public enventName: string) {}
  }

  @logDispatcher
  export class GetContractMessagesSuccess {
    static readonly type = '[MessageStatus] GetContractMessagesSuccess';
    constructor(public contractMessages: StartCourseMessage[]) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[MessageStatus] Error';
    constructor(public error: any) {}
  }
}
